import React from 'react';
import { notification, Spin } from 'antd';

export function openLoadingNotification({ key, message, description = 'Thanks for your patience.' }) {
  notification.open({
    key,
    message: (
      <span className="cc-loading-notification__message">
        <Spin size="small" />
        <span>{message}</span>
      </span>
    ),
    description,
    duration: 0,
    className: 'cc-loading-notification',
  });
}

export function closeLoadingNotification(key) {
  notification.close(key);
}
